module.exports = __webpack_public_path__ + "7b508cec2665f2924919e895ba12143e.fbx";